import { RouteParams } from 'vue-router'
import { isUuid } from '~/services/uuid'

export function areRouteUuidParamsValid(params: RouteParams, uuidParamNames: string[]): boolean {
	return uuidParamNames.every((paramName) => isUuid(params[paramName] as string))
}

const DEFAULT_INVALID_UUID_STATUS = 500

export default defineNuxtRouteMiddleware((to) => {
	const uuidParams = to.meta.uuidParams as string[] | undefined
	if (!uuidParams?.length) return

	const invalidUuidStatus = to.meta.invalidUuidStatus as number | undefined
	if (!areRouteUuidParamsValid(to.params, uuidParams))
		throw createError({
			status: invalidUuidStatus ?? DEFAULT_INVALID_UUID_STATUS,
			message: 'Bad generation for UUID',
			fatal: true,
		})
})
